import { render } from "./app-text-icon.vue?vue&type=template&id=632d7e0c"
import script from "./app-text-icon.vue?vue&type=script&lang=js"
export * from "./app-text-icon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/text/app-text-icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "632d7e0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('632d7e0c', __exports__)) {
    console.log('reload')
    api.reload('632d7e0c', __exports__)
  }
  
  module.hot.accept("./app-text-icon.vue?vue&type=template&id=632d7e0c", () => {
    console.log('re-render')
    api.rerender('632d7e0c', render)
  })

}


export default __exports__